import { render, staticRenderFns } from "./ExtraFieldsEdit.vue?vue&type=template&id=2620c113&scoped=true"
import script from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldsEdit.vue?vue&type=style&index=0&id=2620c113&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620c113",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2620c113')) {
      api.createRecord('2620c113', component.options)
    } else {
      api.reload('2620c113', component.options)
    }
    module.hot.accept("./ExtraFieldsEdit.vue?vue&type=template&id=2620c113&scoped=true", function () {
      api.rerender('2620c113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtraFieldsEdit.vue"
export default component.exports